import { Layout } from '@/utils/routerHelper'

// 财务管理
export default {
  path: '/finance',
  redirect: '/finance/client-wallet',
  component: Layout,
  name: 'Finance',
  meta: {
    title: '财务管理',
    icon: 'vi-ant-design:dashboard-filled',
    alwaysShow: true
  },
  children: [
    {
      path: 'client-wallet',
      component: () => import('@/views/Finance/ClientWallet/Index.vue'),
      name: 'ClientWallet',
      meta: {
        title: '顾客钱包查询'
      }
    },
    {
      path: 'wallet-reconciliation',
      name: 'WalletReconciliation',
      component: () => import('@/views/Finance/ClientWallet/WalletReconciliation/Index.vue'),
      meta: {
        title: '现金钱包对账表',
        canTo: true,
        hidden: true,
        activeMenu: '/finance/client-wallet'
      },
      children: [
        {
          path: 'detail',
          name: 'WalletReconciliationDetail',
          component: () =>
            import('@/views/Finance/ClientWallet/WalletReconciliation/Detail/Index.vue'),
          meta: {
            title: '查看详情',
            hidden: true,
            canTo: true,
            activeMenu: '/finance/client-wallet'
          }
        },
        {
          path: 'history',
          name: 'WalletReconciliationHistory',
          component: () =>
            import('@/views/Finance/ClientWallet/WalletReconciliation/History/Index.vue'),
          meta: {
            title: '历史数据',
            hidden: true,
            canTo: true,
            activeMenu: '/finance/client-wallet'
          }
        }
      ]
    },
    {
      path: 'gift-voucher-reconciliation',
      name: 'GiftVoucherReconciliation',
      component: () => import('@/views/Finance/ClientWallet/GiftVoucherReconciliation/Index.vue'),
      meta: {
        title: '电子礼券对账单',
        canTo: true,
        hidden: true,
        activeMenu: '/finance/client-wallet'
      }
    },
    {
      path: 'coupon-reconciliation',
      name: 'CouponReconciliation',
      component: () => import('@/views/Finance/ClientWallet/CouponReconciliation/Index.vue'),
      meta: {
        title: '优惠券对账单',
        canTo: true,
        hidden: true,
        activeMenu: '/finance/client-wallet'
      }
    },
    {
      path: 'reconciliation',
      name: 'AndouReconciliation',
      component: () => import('@/views/Finance/ClientWallet/Reconciliation/Index.vue'),
      meta: {
        title: '安豆对账表',
        canTo: true,
        hidden: true,
        activeMenu: '/finance/client-wallet'
      }
    },
    {
      path: 'public-reconciliation',
      name: 'PublicAndouReconciliation',
      component: () => import('@/views/Finance/ClientWallet/Public/Reconciliation/Index.vue'),
      meta: {
        title: '公共区安豆对账表',
        canTo: true,
        hidden: true,
        activeMenu: '/finance/client-wallet'
      }
    },
    {
      path: 'account-general-ledger',
      name: 'AccountGeneralLedger',
      component: () => import('@/views/Finance/ClientWallet/AccountGeneralLedger/Index.vue'),
      meta: {
        title: '账号总账报表',
        canTo: true,
        hidden: true,
        activeMenu: '/finance/client-wallet'
      }
    },
    {
      path: 'public-account-general-ledger',
      name: 'PublicAccountGeneralLedger',
      component: () => import('@/views/Finance/ClientWallet/Public/AccountGeneralLedger/Index.vue'),
      meta: {
        title: '公共区账户总账报表',
        canTo: true,
        hidden: true,
        activeMenu: '/finance/client-wallet'
      }
    },
    {
      path: 'public-wallet-reconciliation',
      name: 'PublicWalletReconciliation',
      component: () => import('@/views/Finance/ClientWallet/Public/WalletReconciliation/Index.vue'),
      meta: {
        title: '公共区现金钱包对账表',
        canTo: true,
        hidden: true,
        activeMenu: '/finance/client-wallet'
      },
      children: [
        {
          path: 'history',
          name: 'PublicWalletReconciliationHistory',
          component: () =>
            import('@/views/Finance/ClientWallet/Public/WalletReconciliation/History/Index.vue'),
          meta: {
            title: '历史数据',
            hidden: true,
            canTo: true,
            activeMenu: '/finance/client-wallet'
          }
        }
      ]
    },
    {
      path: 'manual-setting-audit',
      component: () => import('@/views/Finance/ManualSettingAudit/Index.vue'),
      name: 'ManualSettingAudit',
      meta: {
        title: '手工审核调整'
      }
    },
    {
      path: 'gift-withdraw-audit',
      component: () => import('@/views/Finance/GiftWithdrawAudit/Index.vue'),
      name: 'GiftWithdrawAudit',
      meta: {
        title: '礼券提现审核'
      }
    },
    {
      path: 'client-transaction-details',
      component: () => import('@/views/Finance/ClientTransactionDetails/Index.vue'),
      name: 'ClientTransactionDetails',
      meta: {
        title: '顾客交易明细'
      }
    },
    {
      path: 'public-client-transaction-details',
      component: () => import('@/views/Finance/ClientTransactionDetails/Public/Index.vue'),
      name: 'PublicClientTransactionDetails',
      meta: {
        title: '公共区顾客交易明细'
      }
    },
    {
      path: 'payment-record',
      component: () => import('@/views/Finance/PaymentRecord/Index.vue'),
      name: 'PaymentRecord',
      meta: {
        title: '支付流水查询'
      }
    },
    {
      path: 'remittance-declaration',
      component: () => import('@/views/Finance/RemittanceDeclaration/Index.vue'),
      name: 'RemittanceDeclaration',
      meta: {
        title: '汇款申报管理'
      }
    },
    {
      path: 'invoice-apply-record',
      component: () => import('@/views/Finance/InvoiceApplyRecord/Index.vue'),
      name: 'InvoiceApplyRecord',
      meta: {
        title: '发票申请记录'
      },
      children: [
        {
          path: 'invoice-goods-details',
          component: () =>
            import('@/views/Finance/InvoiceApplyRecord/InvoiceGoodsDetails/Index.vue'),
          name: 'InvoiceGoodsDetails',
          meta: {
            title: '开票商品明细',
            hidden: true,
            canTo: true,
            activeMenu: '/finance/invoice-apply-record'
          }
        },
        {
          path: 'invoice-reconciliation',
          component: () =>
            import('@/views/Finance/InvoiceApplyRecord/InvoiceReconciliation/Index.vue'),
          name: 'InvoiceReconciliation',
          meta: {
            title: '发票对账表',
            hidden: true,
            canTo: true,
            activeMenu: '/finance/invoice-apply-record'
          }
        }
      ]
    }
  ]
} as AppRouteRecordRaw
